import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Collapse } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//STYLES
import { ContainerPontosAdicionados } from './styled';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../../../Components/ButtonCustom';

interface PropsAdicionados {
    pontos_selecionados_adicionados: any[]
    fake_loading: boolean
    deletarPontosSelecionados: Function
}

export const PontosAdicionados: React.FC<PropsAdicionados> = ({ pontos_selecionados_adicionados, fake_loading, deletarPontosSelecionados }) => {

    const { Panel } = Collapse

    return (
        <ContainerPontosAdicionados>
            <Collapse accordion>
                {pontos_selecionados_adicionados.map((item, index) => (
                    <Panel
                        key={index}
                        header={
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 5,
                                }}
                            >
                                <span style={{ margin: 0, padding: 0, fontWeight: 600 }}>{item.profundidade}</span>
                                <div
                                    style={{
                                        width: '25px',
                                        height: '25px',
                                        backgroundColor: item?.cor,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: 'white',
                                        padding: '5px',
                                    }}
                                >
                                    {index + 1}
                                </div>
                            </div>
                        }
                    >
                        <div className='container__adicionados'>
                            <div className='header__adicionados'>
                                <div className='nome__analise' style={{ backgroundColor: item?.cor }}>
                                    {item?.analise_nome}
                                </div>
                                <div>
                                    <ButtonCustom
                                        onClick={() => deletarPontosSelecionados(item?.id)}
                                        danger
                                        loading={fake_loading}
                                        disabled={fake_loading}
                                        icon={<FontAwesomeIcon icon={faTrash} />}
                                    />
                                </div>
                            </div>

                            <h3 className='points-title'>Pontos</h3>

                            <div className='points-grid'>
                                {item?.pontos_selecionados?.map((point, index) => (
                                    <div
                                        key={index}
                                        className='point-card'
                                        style={
                                            {
                                                '--cor-do-item': point?.COR,
                                            } as React.CSSProperties
                                        }
                                    >
                                        {point?.NOME.toString().padStart(2, '0')}{' '}
                                        {/* Garante 2 dígitos (07, 09...) */}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Panel>
                ))}
            </Collapse>
        </ContainerPontosAdicionados>
    )
}
